import script from "./PageLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./PageLoader.vue?vue&type=script&setup=true&lang=js"

import "./PageLoader.vue?vue&type=style&index=0&id=297a0cfd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-297a0cfd"]])

export default __exports__